<!-- Component that is used to make video call -->
<template>
  <div class="media-container">
    <div v-if="accessToken" ref="twilioTracks" class="video" />
    <div class="absolute z3 right-0 top-0 mr2 mt2">
      <v-button type="button" variant="icon" @click="$emit('toggleFullscreen')">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <g stroke="#FFF" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <path d="M15.5 8.5l8-8M.5 23.5l8-8M5.5 23.5h-5v-5M23.5 5.5v-5h-5M15.5 15.5l8 8M.5.5l8 8M.5 5.5v-5h5M18.5 23.5h5v-5"/>
          </g>
        </svg>
      </v-button>
    </div>
    <div v-if="status === Status.ERROR" class="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
      <v-button type="button" class="z3" @click="connect">Yritä uudelleen</v-button>
    </div>
    <div class="video-controls z2 flex items-end justify-between p2">
      <v-button v-if="isAudioMuted" type="button" variant="circle dark-blue" @click="unmuteAudio">
        <svg width="23" height="24" viewBox="0 0 23 24" xmlns="http://www.w3.org/2000/svg">
          <g stroke="#FFEAEA" fill="none" fill-rule="evenodd" stroke-linejoin="round">
            <path d="M14.024 18.189a6.536 6.536 0 0 1-2.001.311c-3.466 0-6.273-2.687-6.273-6V10M6.319 4C7.309 1.935 9.49.5 12.023.5c3.463 0 6.272 2.687 6.272 6v6c0 .893-.204 1.739-.57 2.5M19.3 16.492a7.789 7.789 0 0 0 1.086-3.992v-2" stroke-linecap="round"/>
            <path d="M3.66 10.5v2c0 4.474 3.684 8 8.363 8a8.73 8.73 0 0 0 4.157-1.031" stroke-linecap="round"/>
            <path d="M12.023 20.5V24"/>
            <path d="M0 1l23 22" stroke-linecap="round"/>
          </g>
        </svg>
      </v-button>
      <v-button v-else type="button" variant="circle" @click="muteAudio">
        <svg width="18" height="24" viewBox="0 0 18 24" xmlns="http://www.w3.org/2000/svg">
          <g stroke="#003665" fill="none" fill-rule="evenodd">
            <rect x="2.57" y=".725" width="12.083" height="17.45" rx="6.041"/>
            <path d="M.571 10.5v2c0 4.474 3.553 8 8.063 8a8.177 8.177 0 0 0 4.009-1.031" stroke-width="1.012" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.654 10.5v2c0 4.474-3.553 8-8.063 8a8.177 8.177 0 0 1-4.008-1.031" stroke-width="1.012" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.634 20.5V24" stroke-width="1.012" stroke-linejoin="round"/>
            <path d="M7.76 1.125v3.75M9.978 1.125v3.75" stroke-width="1.012" stroke-linecap="round"/>
          </g>
        </svg>
      </v-button>
      <div class="status-message flex flex-column self-start items-center mx2 mt1 h5 semibold">
        <div>{{statusMessage}}</div>
        <div v-if="isAudioMuted">Mikrofoni mykistetty</div>
      </div>
      <v-button type="button" variant="circle red" @click="disconnect(); $emit('stopCall');">
        <svg width="24" height="8" viewBox="0 0 24 8" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.391.982C22.832 1.287 24 2.7 24 4.222V5.84C24 7.02 23.054 8 21.913 8h-3.13c-1.14 0-2.087-.98-2.087-2.16V4.762a46.427 46.427 0 0 0-9.392 0v1.08C7.304 7.02 6.358 8 5.217 8h-3.13C.947 8 0 7.02 0 5.84V4.222C0 2.7 1.168 1.287 2.609.982a45.393 45.393 0 0 1 18.782 0z" fill="#FFF" fill-rule="evenodd"/>
        </svg>
      </v-button>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';
import { connect } from 'twilio-video';

const Status = {
  CONNECTING: Symbol('connecting'),
  CONNECTED: Symbol('connected'),
  DISCONNECTING: Symbol('disconnecting'),
  ERROR: Symbol('error'),
};

export default {
  components: {
    Modal,
    'v-button': Button,
  },
  props: {
    chat: Object,
    accessToken: String,
  },
  data () {
    return {
      Status,

      status: Status.CONNECTING,
      twilioRoom: null,
      connectedParticipants: 0,
      participantConnectTime: null,
      isAudioMuted: false,

      currentTime: performance.now(),
      currentTimeInterval: null,
    };
  },
  computed: {
    statusMessage() {
      switch (this.status) {
        case Status.CONNECTING:
          return 'Yhdistetään';

        case Status.CONNECTED:
          break;

        case Status.DISCONNECTING:
          return 'Suljetaan';

        case Status.ERROR:
        default:
          return 'Virhe';
      }

      if (this.connectedParticipants < 1) {
        return 'Odotetaan asiakasta';
      }

      const seconds = Math.trunc((this.currentTime - this.patientConnectTime) / 1000);
      const time = ("0" + Math.trunc(seconds / 60)).slice(-2) + ':' + ("0" + seconds % 60).slice(-2);

      return `Videopuhelu ${time}`;
    },
  },
  mounted() {
    this.status = Status.CONNECTING;

    this.currentTimeInterval = setInterval(() => {
      this.currentTime = performance.now();
    }, 500);
  },
  beforeDestroy() {
    clearInterval(this.currentTimeInterval);
  },
  methods: {
    connect() {
      if (!this.accessToken) {
        return;
      }

      this.status = Status.CONNECTING;

      connect(this.accessToken, {
        name: this.chat.pet.petId,
        region: 'de1',
        audio: true,
        video: false,
      }).then((room) => {
        this.twilioRoom = room;
        if (this.status === Status.DISCONNECTING) {
          this.disconnect();
          return;
        }

        this.status = Status.CONNECTED;
        this.refreshAudioMute();

        room.participants.forEach((participant) => {
          participant.tracks.forEach((publication) => {
            if (publication.track && publication.isSubscribed) {
              this.$refs.twilioTracks.appendChild(publication.track.attach());
            }
          });
        });

        const onParticipantsUpdated = () => {
          this.connectedParticipants = [...room.participants.values()].filter((p) => p.state === 'connected').length;

          if (!this.patientConnectTime && this.connectedParticipants > 0) {
            this.patientConnectTime = performance.now();
          }
        };

        const eventHandler = (events, listener) => {
          (Array.isArray(events) ? events : [events]).forEach((event) => {
            room.on(event, (...args) => {
              if (room === this.twilioRoom) {
                listener(...args);
              }
            });
          });
        };

        eventHandler('reconnecting', (error) => {
          if (error) {
            console.error(error);
          }

          if (this.status === Status.CONNECTED) {
            this.status = Status.CONNECTING;
          }
        });
        eventHandler('reconnected', () => {
          if (this.status === Status.CONNECTING) {
            this.status = Status.CONNECTED;
          }
        });
        room.on('disconnected', (_, error) => {
          if (error) {
            console.error(error);
          }

          room.localParticipant.tracks.forEach((publication) => {
            const { track } = publication;
            if (track) {
              track.stop();
              track.detach().forEach((element) => element.remove());
            }
          });

          if (room == this.twilioRoom) {
            const isErrorStatus = this.status !== Status.DISCONNECTING;

            this.twilioRoom = null;
            this.disconnect();

            if (isErrorStatus) {
              this.status = Status.ERROR;
            }
          }
        });

        eventHandler('trackSubscribed', (track) => {
          this.$refs.twilioTracks.appendChild(track.attach());
        });
        eventHandler('trackUnsubscribed', (track) => {
          track.detach().forEach((element) => element.remove());
        });

        eventHandler(['participantConnected', 'participantDisconnected', 'participantReconnecting', 'participantReconnected'], onParticipantsUpdated);

        onParticipantsUpdated();

        if (this.status === Status.DISCONNECTING) {
          this.disconnect();
        }
      }, (error) => {
        if (error) {
          console.error(error);
        }

        if (this.status === Status.CONNECTING) {
          this.status = Status.ERROR;
        }
      });
    },
    disconnect() {
      const room = this.twilioRoom;

      this.status = Status.DISCONNECTING;
      this.twilioRoom = null;
      this.connectedParticipants = 0;
      this.patientConnectTime = null;

      if (room) {
        room.disconnect();
      }
    },
    muteAudio() {
      this.isAudioMuted = true;
      this.refreshAudioMute();
    },
    unmuteAudio() {
      this.isAudioMuted = false;
      this.refreshAudioMute();
    },
    refreshAudioMute() {
      if (!this.twilioRoom) {
        return;
      }

      this.twilioRoom.localParticipant.audioTracks.forEach((publication) => {
        if (!this.isAudioMuted) {
          publication.track.enable();
        } else {
          publication.track.disable();
        }
      });
    }
  },
  watch: {
    accessToken: {
      handler() {
        this.disconnect();
        this.connect();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
  .video-controls {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .video {
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .status-message {
    color: white;
    text-shadow: 1px 0px 2px black, -1px 0px 2px black, 0px 1px 2px black, 0px -1px 2px black;
  }
</style>
